import React from "react";

import "./loading.css";

function LoadingHome() {
  return (
    <div className="">
      <div class="loader">Loading...</div>
    </div>
  );
}

export default LoadingHome;
